export default __webpack_public_path__ + "static/media/Exo-ExtraBold.55504e4c.ttf";